<script>
  import resources from './resources'

  export default {
    name: 'identification',

    mixins: [resources]
  }
</script>

<template lang="pug">
  section.gadget-identificacao-profissional.white-bg.wrapper.gadget.full-width
    .gadget-title
      | Perfil Empregados
    .actions
      span.icon 
      ul
        li.exclude Remover
        li.half-width Lado a Lado
        li.full-width Tela Inteira
    .col-xs-8.col-xs-offset-2.col-md-2.col-md-offset-0.col-lg-offset-0.profile-picture
      img.img-circle(:src='user.avatar')
    .col-xs-12.col-md-5
      label.light-red Profissional
      h2.medium-gray {{ user.name }}
      label.light-red Especialidade Médica
      h3.medium-gray {{ speciality }}
    .half-width-margin
    .col-xs-12.col-md-5
      label.light-red CRM
      h2.medium-gray {{user.document}}-{{user.state}}
</template>



// WEBPACK FOOTER //
// src/app/team/dashboard/gadget/components/identification/identification.vue